import {Component, OnInit, inject} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {LandingComponent} from "./components/landing/landing.component";
import {EventsManager} from "./events/events.manager";
import {PlansService} from "./services/plans.service";
import * as _ from "underscore";
import { DataService } from './services/data.service';
import { SupportInformation } from './models/SupportInformation.model';
import {environment} from "../environments/environment";
import { LegalModel } from './models/legal.model';
import { ErrorService } from './services/error.service';
import { MainPageDetailModel } from './models/plans.model';
import {ThemeV2Service} from "./services/theme-v2.service";
import {BrandRequest} from "./models/requests/brand.request";
import {Theme, themes} from "./models/Theme";
import {IThemeConfig} from "./models/theme.entity";
import {DOCUMENT} from "@angular/common";
import {adjustLightness} from "../app/utils/color.util";
import { BrandThemeResponse } from './models/requests/brand-theme.response';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  private document: Document = inject(DOCUMENT)
  office?: MainPageDetailModel = undefined;
  geoSaved:boolean = false;
  showSubHeader: boolean = true;
  legal:any = {};
  adminBy:string = '';

  constructor(public modalService: NgbModal, private route: ActivatedRoute, private em: EventsManager, private service: PlansService, private dataService: DataService, private themeService: ThemeV2Service,private errorService: ErrorService) {

  }
  ngOnInit() {
    let host:string = window.location.host;
    this.em.orgId = '00000000-0000-0000-0000-000000000000';
    if(!this.geoSaved && window.location.pathname === '/'){
      this.openGeoModal();
    } else if(window.location.pathname.split('/')[2] && window.location.pathname.split('/')[2].length > 0 && window.location.pathname.split('/')[1] === 'office' ){
      this.getOffice(window.location.pathname.split('/')[2]);
    } else if(window.location.pathname.split('/')[1] && window.location.pathname.split('/')[1].length > 0 && window.location.pathname.split('/')[1] !== 'purchase'){
      let args = window.location.pathname.split('/');
      if(args[2] && args[2].length > 0) {
        this.getOfficeByVanity(args[1],args[2]);
      }
      else if(args[1] !== 'purchase')
      {
        this.getOfficeByVanity('',args[1]);
      }

    } else {
      let off:any = JSON.parse(sessionStorage['office']);
      this.getOffice(off.practiceId);
    }
    this.em.showHideSubheader.subscribe((data:boolean) =>{
      this.showSubHeader = data;
    })

    // this.em.setNewTheme.subscribe(
    //   (result:any) => {
    //     this.setDefaultTheme();
    //   }
    // )
    this.em.setNewCustTheme.subscribe(
      (theme:any) => {
        console.log(':::THEME::: ', theme);
        //this.setCustTheme(theme);
      }
    )
    window.addEventListener("message", this.receiveMessage, false);
  }

  receiveMessage = (event: any) => {
    const message = event.data.message;
    if(message === 'action_scroll'){
      window.scrollTo(0,0);
    }


    if (message === 'action_resize') {
      const newHeight = event.data.height;
      const purchaseWidget = document.getElementById('purchase-widget');
      if (purchaseWidget) {
        purchaseWidget.style.height = `${newHeight + 10}px`;
      }
    }
  }

  openGeoModal():void {
    const modalRef: NgbModalRef = this.modalService.open(LandingComponent);
    modalRef.result.then(
      (result: any) => {
        this.getOffice(result);
        this.closeModal();
      },
      error => {
        console.log('dia error: ', error);
      }
    )
  }

  closeModal() {
    // need stuff here
    this.modalService.dismissAll();

  }

  setDisplayInfo(office:any){
    this.office = office;
    this.showSubHeader = true;
    this.em.subHeaderShowHide(true);
    this.getLegalLanguage();
  }

  getOffice(office:string){
    this.service.getOffice(office).subscribe(
      (result:MainPageDetailModel) => {
        this.office = result;
        this.setAdminBy(this.office.benefitPlanTemplates[0]?.isAdminBy);
        this.em.docOrgId = this.office.organizationId;
        this.setDisplayInfo(this.office);
        this.em.setOfficeInfo(this.office);
        this.setSupportInfo(this.office);
        this.getTheme();
      },
      (error) => {
        if (error.status === 400 && Array.isArray(error.error)) {
          this.processValidationError(error.error);
        } else {
          // Handle other types of errors
         // console.log('General Error: ', error);
        }
      }
    );
  }

  processValidationError(validationErrors: any) {
   // console.log('Validation Errors: ', validationErrors);
    if (Array.isArray(validationErrors) && validationErrors.length > 0) {
      this.errorService.showError(validationErrors[0].message);
    }
  }

  getOfficeByVanity(orgVanity:string, practiceVanity:string){
    this.service.getOfficeByVanityName(orgVanity,practiceVanity).subscribe(
      (result:MainPageDetailModel) => {
        this.office = result;
        if (this.office?.benefitPlanTemplates) {
          this.setAdminBy(this.office?.benefitPlanTemplates[0]?.isAdminBy);
        }
        this.em.docOrgId = this.office?.organizationId ?? '';
        this.setDisplayInfo(this.office);
        this.em.setOfficeInfo(this.office);
        this.setSupportInfo(this.office);
        this.getTheme();

      },
      (error) => {
     //   console.error('Error occurred: ', error);

        if (error.status === 400 && Array.isArray(error.error)) {
          console.log('Validation error: ', error.error);
        } else {
          // Handle other types of errors
          console.log('General Error: ', error);
        }
      }
    )
  }

  setSupportInfo(office?:MainPageDetailModel){

    let supportInfo: SupportInformation = {
        PhoneNumber: this.office?.telephoneNumber ?? '',
        MailingAddress: this.office?.address ?? '',
        EmailAddress: this.office?.emailSupport ?? '',
        WeekdayHours: this.office?.weekdayHours ?? '',
        WeekendHours: this.office?.weekendHours ?? ''
    }
    this.dataService.setSupportInfo(supportInfo);
  }

  getLegalLanguage(){
    this.service.getLegalLanguage().subscribe(
      (result:LegalModel) => {
        this.legal = result;
        if(this.adminBy == ''){
          this.adminBy = 'wellfit';
        }
        this.em.setLegalLanguage(_.findWhere(this.legal,{adminBy:this.adminBy}));
      }
    )
  }

  getTheme(){
    let theme:BrandRequest = {
      themeId: '',
      brand:this.office!.benefitPlanTemplates[0]!.branding,
      organization: this.office?.organizationId ?? this.em.orgId,
      practice:''
    }
    this.themeService.getTheme(theme).subscribe(
      (result:any) => {
        console.log('::THEME:: ',result);
        console.log(result.length);
        if(result && result.colorPrimary !== ''){
          this.setCustTheme(result);
        } else {
          this.setDefaultTheme();
        }
      }
    )
  }

  setAdminBy(who:any) {
    if(who.length == 1){
      switch(who){
        case '0':
          this.adminBy = 'wellfit';
          break;
        case '1':
          this.adminBy = 'careington';
          break;
      }
    } else {
      this.adminBy = this.office?.benefitPlanTemplates[0]?.isAdminBy ?? 'wellfit';
    }
  }
  setDefaultTheme() {
    Theme.applyTheme(themes.default, this.document)
  }

  setCustTheme(theme: any) {
    console.log(theme);
    if (theme.hasOwnProperty('colorPrimary')) {
      const customThemeConfig: IThemeConfig = {
        primary:
          theme.colorPrimary ||
          themes.default.themeProperties['--color-primary'],
        primary80:
          theme.colorPrimary80 ||
          adjustLightness(theme.colorPrimary, -25),
        primary60:
          theme.colorPrimary60 ||
          adjustLightness(theme.colorPrimary, -15),
        primary20:
          adjustLightness(theme.colorPrimary, 40) ||
          themes.default.themeProperties['--color-primary20'],
        onPrimary:
          theme.colorsOnPrimary ||
          themes.default.themeProperties['--color-on-primary'],
        surface:
          theme.colorSurface ||
          themes.default.themeProperties['--color-surface'],
        onSurface:
          theme.colorOnSurface ||
          themes.default.themeProperties['--color-on-surface'],
        surfaceAvatar:
          theme.colorSurfaceAvatar ||
          themes.default.themeProperties['--color-surface-avatar'],
        onSurfaceAvatar:
          theme.colorOnSurfaceAvatar ||
          themes.default.themeProperties['--color-on-surface-avatar'],
        surfaceVariant:
          theme.colorSurfaceVariant ||
          themes.default.themeProperties['--color-surface-variant'],
        selectedGroup:
          theme.colorSelectedGroup ||
          themes.default.themeProperties['--color-selected-group'],
        selectedItem:
          theme.colorSelectedItem ||
          themes.default.themeProperties['--color-selected-item'],
        selectedItemHover:
          theme.colorSelectedItemHover ||
          themes.default.themeProperties['--color-selected-item-hover'],
        onSelectedItem:
          theme.colorOnSelectedItem ||
          themes.default.themeProperties['--color-on-selected-item'],
        surfaceContainer:
          theme.colorSurfaceContainer ||
          themes.default.themeProperties['--color-surface-container'],
        surfaceLogo:
          theme.surfaceLogo ||
          themes.default.themeProperties['--color-surface-logo'],
      };
      this.em.setNewCustTheme.emit(customThemeConfig);
      this.em.setThemeId(theme?.themeId || '');
      Theme.applyTheme(new Theme(customThemeConfig), this.document);
    }
  }
}
